import { isAgentBrandShow as getIsAgentBrandShow, isDealAndProfi, isPublishedUser } from './helpers';
import { EUserTrustLevel } from '../../types/offer';
import * as React from 'react';
import * as PropTypes from 'prop-types';

import { PartnerTooltip } from '../../components/PartnerTooltip';
import { IconBlacklist, IconWhitelist } from './icons';
import { IUserInfoContext, TUserInfoType } from './';
import { HonestWorkHorizontal } from './HonestWorkHorizontal';
import * as style from './index.css';

export class UserInfoHorizontal extends React.Component<{}> {
  public context: IUserInfoContext;

  public static contextTypes = {
    offer: PropTypes.object,
    offerHelper: PropTypes.object,
    user: PropTypes.object,
  };

  public static defaultProps = {
    type: 'vertical' as TUserInfoType,
  };

  public render() {
    const { offer, user, offerHelper } = this.context;
    const { isPro, isByHomeowner } = offer;
    const { tariff, isAgent } = user;

    const userTrustLevel = offerHelper.presenters.getUserTrustLevel();
    const userPersonalRating = offerHelper.presenters.getUserPersonalRating();
    const userId = offerHelper.presenters.getCianUserId();
    const agencyName = offerHelper.presenters.getAgentName();
    const accountType = offerHelper.presenters.getAccountType();
    const isShowLabelOfAccountType = isDealAndProfi(tariff, accountType);
    const isRepresentative = !!(offer.businessShoppingCenter && offer.businessShoppingCenter.fromRepresentative);
    const isHonestwork = userTrustLevel === EUserTrustLevel.Involved;
    const isAgentBrandShow = getIsAgentBrandShow(offer, userTrustLevel);
    const isAgentUser = !!isAgent;
    const isCianPartner = offer.user && offer.user.isCianPartner;
    const isPublicUser = isPublishedUser(offer);

    return (
      <div className={style['userInfoHorizontalContainer']}>
        {isAgentBrandShow && (
          <span className={`${style['userInfo-name']} ${style['userInfo-name--horizontal']}`}>
            <noindex>{agencyName || `ID ${userId}`}</noindex>
          </span>
        )}

        <span className={`${style['userInfo-badges']} ${style['userInfo-badges--horizontal']}`}>
          {isAgentUser && isAgentBrandShow && isPro && (
            <div className={`${style['userInfo-badge']} ${style['userInfo-badge--horizontal']}`}>
              <div className={`${style['userInfo-textBadge']}`}>PRO</div>
            </div>
          )}

          {isAgentBrandShow && isHonestwork && <HonestWorkHorizontal />}

          {isCianPartner && (
            <div className={`${style['userInfo-badge']} ${style['userInfo-badge--horizontal']}`}>
              <PartnerTooltip
                master={<div className={`${style['userInfo-textBadge']} ${style['greenLight']}`}>Партнёр</div>}
              />
            </div>
          )}

          {isByHomeowner && (
            <div className={`${style['userInfo-badge']} ${style['userInfo-badge--horizontal']}`}>
              <div className={`${style['userInfo-textBadge']}`}>Собственник</div>
            </div>
          )}

          {isRepresentative && (
            <div className={style['userInfo-badge']}>
              <div className={`${style['userInfo-textBadge']} ${style['greenLight']}`}>Оф. представитель</div>
            </div>
          )}

          {isPublicUser && isShowLabelOfAccountType && !isRepresentative && (
            <div className={style['userInfo-badge']}>
              <div className={`${style['userInfo-textBadge']} ${style['greenLight']}`}>
                {accountType === 'managementCompany' ? 'Управляющая компания' : 'Отдел аренды'}
              </div>
            </div>
          )}

          {userPersonalRating === 'positive' && (
            <div className={`${style['userInfo-badge']} ${style['userInfo-badge--horizontal']}`}>
              <IconWhitelist isActive />
            </div>
          )}

          {userPersonalRating === 'negative' && (
            <div className={`${style['userInfo-badge']} ${style['userInfo-badge--horizontal']}`}>
              <IconBlacklist isActive />
            </div>
          )}
        </span>
      </div>
    );
  }
}
